// @flow

// NOTE(Ethan): Add as needed
const KeyConstants = {
  ESC: 27,
  ENTER: 23,
  BACKSPACE: 8,
  ARROW_LEFT: 37,
  ARROW_RIGHT: 39,
  DELETE: 46,
  ZERO: 48,
  NINE: 57,
  NUMPAD_ZERO: 96,
  NUMPAD_NINE: 105,
};

export default KeyConstants;



// WEBPACK FOOTER //
// ./src/utils/keycode.js